<template>
  <Preloader />
  <Header />
  <router-view />
</template>

<script>
import Header from '@/layout/Header.vue'
import Preloader from '@/layout/Preloader'
export default {
  name: 'App',
  components: {
    Header,
    Preloader,
  }
}
</script>